module.exports = __webpack_public_path__ + "img/chain-cat-member.eddc0af5.svg";